import { CountryIso3166Schema, LanguageIso6391 } from "@tfg/types/schemas/enum"

import { UpdateBusinessPartnerRequestDto } from "~/gen/api"

export const SUPPLIER_INITIAL_VALUES: UpdateBusinessPartnerRequestDto = {
  supplierId: "",
  name: "",
  email: "",
  preferedLangageIso6391: LanguageIso6391.EN,
  organization: {
    name: "",
    street: "",
    city: "",
    postalCode: "",
    country: CountryIso3166Schema.enum.FR,
    registrationId: [],
    businessRelationship: {
      isActive: true,
      supplierCode: "",
      type: null,
    },
    coordinates: null,
  },
}
